module.exports = __webpack_public_path__ + "static/media/N25.802866b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N25.svg
// module id = 190
// module chunks = 0